// Wishilist js

document.addEventListener("DOMContentLoaded", function () {

  function getWishlist() {
    return JSON.parse(localStorage.getItem("wishlist")) || [];
  }

  function saveWishlist(wishlist) {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }

  function updateWishlistCount() {
    const wishlist = getWishlist();

    const countElement = document.getElementById("wishlist-count");

    if (countElement) {
      countElement.textContent = wishlist.length;
    }
  }

  function refreshWishlistState() {

    const wishlist = getWishlist();

    document.querySelectorAll(".wishlist-btn").forEach(button => {

      const handle = button.dataset.productHandle;

      const emptyIcon = button.querySelector(".wishlist-empty");
      const filledIcon = button.querySelector(".wishlist-filled");

      if (wishlist.find(item => item.handle === handle)) {

        button.classList.add("active");

        if (emptyIcon) {
          emptyIcon.classList.remove("fa-regular");
          emptyIcon.classList.add("fa-solid");
        }

      } else {

        button.classList.remove("active");

        if (emptyIcon) {
          emptyIcon.classList.remove("fa-solid");
          emptyIcon.classList.add("fa-regular");
        }
      }
    });
  }

  // Click Event
  document.addEventListener("click", function (e) {

    const button = e.target.closest(".wishlist-btn");

    if (!button) return;

    const wishlist = getWishlist();

    const product = {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      image: button.dataset.productImage,
      url: button.dataset.productUrl,
      rating: button.dataset.productRating
    };

    const handle = product.handle;

    const icon = button.querySelector(".wishlist-empty");

    const index = wishlist.findIndex(item => item.handle === handle);

    if (index > -1) {

      wishlist.splice(index, 1);

      button.classList.remove("active");

      if (icon) {
        icon.classList.remove("fa-solid");
        icon.classList.add("fa-regular");
      }

    } else {

      wishlist.push(product);

      button.classList.add("active");

      if (icon) {
        icon.classList.remove("fa-regular");
        icon.classList.add("fa-solid");
      }
    }

    saveWishlist(wishlist);

    updateWishlistCount();

  });

  // Initial Load
  updateWishlistCount();

  refreshWishlistState();

  // Global Refresh
  window.refreshWishlistState = refreshWishlistState;

});

$('.color-swatch-slider').owlCarousel({
    loop: false,
    margin: 4,
    nav: false,
    dots: false,
    responsive: {
        0: { items: 4 },
        480: { items: 5 },
        768: { items: 6 },
        1024: { items: 7 }
    }
});


// document.querySelectorAll('.rating-text span').forEach(function(el) {
//   el.innerHTML = el.innerHTML.replace('/ 5.0', '');
// });

// document.querySelectorAll('.rating-text span').forEach(function(el) {
//   el.textContent = el.textContent.split('/')[0].trim();
// });

function updateRatingText() {
  document.querySelectorAll('.rating-text span').forEach(function(el) {
    if (el.textContent.includes('/')) {
      el.textContent = el.textContent.split('/')[0].trim();
    }
  });
}

updateRatingText();

const observer = new MutationObserver(() => {
  updateRatingText();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


document.addEventListener('click', function (e) {
  const cartDrawer = document.querySelector('cart-drawer');

  // Close button click
  if (e.target.closest('#rebuy-cart-close')) {
    cartDrawer?.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    return;
  }

  // Click outside drawer
  if (
    cartDrawer?.classList.contains('active') &&
    !e.target.closest('cart-drawer')
  ) {
    cartDrawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
});

/*
document.addEventListener('click', function (e) {
  const cartDrawer = document.querySelector('cart-drawer');

  // Close button click
  if (e.target.closest('#rebuy-cart-close')) {
    cartDrawer?.classList.remove('active');
    return;
  }

  // Outside click
  if (
    cartDrawer?.classList.contains('active') &&
    !e.target.closest('cart-drawer')
  ) {
    cartDrawer.classList.remove('active');
  }
});*/
